module.exports = __webpack_public_path__ + "img/health-guide-screen.ea2520dc.png";